import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CameraIcon, GiftIcon, ListChecksIcon, QrCodeIcon, VoteIcon } from 'lucide-react';
import { playModes, PlayModeKey } from '../data/playModes';
const ease = [0.23, 1, 0.32, 1] as const;
const icons: Record<PlayModeKey, typeof ListChecksIcon> = {
  quiz: ListChecksIcon,
  poll: VoteIcon,
  checkin: QrCodeIcon,
  photo: CameraIcon,
  draw: GiftIcon
};
export function PlayModes() {
  const [active, setActive] = useState(0);
  return <section id="play" className="bg-forest-deep py-20 text-white lg:py-24" aria-labelledby="play-title" data-id="element-177" data-mp="fl8bww0x0zsu">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-178" data-mp="tlapi626x72a">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-179" data-mp="thvbl6k9642g">
          <div data-id="element-180" data-mp="on98rrs8ljtz">
            <p className="font-display text-sm font-bold tracking-[0.2em] text-mint" data-id="element-181" data-mp="24zegd3dhef34">AVEGA PLAY</p>
            <h2 id="play-title" className="mt-4 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] sm:text-5xl" data-id="element-182" data-mp="200bn0g6v5xaz">
              Five ways to play.
            </h2>
          </div>
          <p className="max-w-md text-lg leading-relaxed text-white/65" data-id="element-183" data-mp="30065kzzt804r">
            Every action is set up for a real event, with clear rules before you start and no hidden catches.
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3 lg:h-[420px] lg:flex-row" data-id="element-184" data-mp="39y2fjoh0gp1a">
          {playModes.map((mode, i) => {
          const isActive = i === active;
          const Icon = icons[mode.key];
          return <motion.div key={mode.key} role="button" tabIndex={0} aria-expanded={isActive} aria-label={mode.title} onClick={() => setActive(i)} onMouseEnter={() => setActive(i)} onFocus={() => setActive(i)} onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setActive(i);
            }
          }} animate={{
            flexGrow: isActive ? 3.6 : 1
          }} transition={{
            duration: 0.3,
            ease
          }} style={{
            flexBasis: 0
          }} className={`leaf-md relative cursor-pointer overflow-hidden bg-forest outline-none ring-mint focus-visible:ring-2 ${isActive ? 'min-h-[320px] lg:min-h-0' : 'min-h-[84px] lg:min-h-0'}`} data-id="element-185" data-mp="2h8n3cvdm0q3s" data-mpi={i}>
                <img src={mode.image} alt="" className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-300 ease-out ${isActive ? 'opacity-100' : 'opacity-0'}`} data-id="element-186" data-mp="13jut065a0n2s" />
                <div className={`absolute inset-0 transition-colors duration-300 ${isActive ? 'bg-forest-deep/60' : 'bg-forest'}`} data-id="element-187" data-mp="2sx7yvzt1ej60" />
                <div className={`relative z-10 flex h-full p-6 ${isActive ? 'flex-col justify-between' : 'flex-row items-center gap-4 lg:flex-col lg:items-start lg:justify-between'}`} data-id="element-188" data-mp="9q3x1xo52j0c">
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-full transition-colors duration-200 ${isActive ? 'bg-mint text-forest-deep' : 'bg-white/10 text-mint'}`} data-id="element-189" data-mp="5qlgfe3cou3b">
                    <Icon className="h-5 w-5" data-id="element-190" data-mp="jpuua7433c44" />
                  </span>
                  {isActive ? <motion.div key="open" initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.25,
                ease,
                delay: 0.08
              }} data-id="element-191" data-mp="onmleywwmu79">
                      <h3 className="font-display text-2xl font-bold tracking-tight lg:text-3xl" data-id="element-192" data-mp="3ooa99nz27gp7">{mode.title}</h3>
                      <p className="mt-3 max-w-sm leading-relaxed text-white/85" data-id="element-193" data-mp="3jpgttq07pfme">{mode.description}</p>
                      <p className="mt-5 inline-flex rounded-full bg-white/15 px-3 py-1 text-sm font-semibold text-mint backdrop-blur" data-id="element-194" data-mp="3fn3pn6145prq">
                        {mode.note}
                      </p>
                    </motion.div> : <h3 className="whitespace-nowrap font-display text-lg font-semibold tracking-tight lg:rotate-180 lg:[writing-mode:vertical-rl]" data-id="element-195" data-mp="b8lzx01e75kg">
                      {mode.title}
                    </h3>}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}